export default "__VITE_ASSET__CaYC8D1M__"